import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Buyer } from 'src/app/core/buyers.service';

@Component({
  selector: 'app-buyer-details-general-aml',
  templateUrl: './buyer-details-general-aml.component.html',
  styleUrls: ['./buyer-details-general-aml.component.scss'],
})
export class BuyerDetailsGeneralAmlComponent {
  @Input() buyer?: Buyer;
  @Output() refresh: EventEmitter<void> = new EventEmitter<void>();
}
